import { BASICUSERS, PERSONA } from 'constants/constant';

const {
	SUPPLIER,
	LIMITED_ACCESS_MERCHANT,
	CATMAN,
	FULL_ACCESS_MERCHANT,
	BASIC_VENDOR,
	BASIC_CATMAN
} = PERSONA;

const INTERNAL = 'INTERNAL';

const UserPersona = (_o) => {
	let userPersona = SUPPLIER;
	const { userType, catManUser, blackOut, sbu, companyType, companyName } = _o.result;

	if (userType === INTERNAL) {
		if (blackOut) {
			//  blackOut: true (FULL ACCESS MERCHANT)
			userPersona = FULL_ACCESS_MERCHANT;
		} else if (!blackOut && sbu !== undefined && sbu.length > 0) {
			//  blackOut: FALSE && SBU:[] (LIMITED ACCESS MERCHANT)
			userPersona = LIMITED_ACCESS_MERCHANT;
		} else if (companyName === undefined || companyName?.length === 0) {
			// blackOut: undefined (SUPPLIER)
			userPersona = FULL_ACCESS_MERCHANT;
		} else {
			userPersona = SUPPLIER;
		}
	} else {
		// here, userType is EXTERNAL
		if (catManUser) {
			if (BASICUSERS.includes(companyType)) {
				//BASIC CATMAN
				userPersona = BASIC_CATMAN;
			} else {
				//isCatmanUser - true (CATMAN)
				userPersona = CATMAN;
			}
		} else {
			if (BASICUSERS.includes(companyType)) {
				//BASIC VENDOR
				userPersona = BASIC_VENDOR;
			} else {
				// isCatmanUser - false (SUPPLIER)
				userPersona = SUPPLIER;
			}
		}
	}

	const o = {
		..._o,
		result: { ..._o.result, userPersona }
	};
	return o;
};

export default UserPersona;
